import React from 'react';
import PropTypes from 'prop-types';

import { getFlowType, getAPPID, isCBandProQualifiedSession, getLTEUpgrade, isVFEligibile, getSession } from '../../../Helpers/index';
import { getProductRefData } from '../../../../../utils/plansReference';
import CommonSection, { filterProducts } from '../../redesign/component/commonSection';
import { getItemFromStore } from '../../../../../utils/sessionStorage';

const Product = (props) => {
  const { dueTodayList, plansReferenceData, dueMonthlyList, dueMonthlyAmount, dueMonthlyProd, dueTodayHomePhoneList, taxFeeText, npaNXXVal } = props;

  const getProdNameorCBandProQualifiedSession = (frequency, planInfo) => {
    if (frequency === 'monthly')
      return planInfo?.[0]?.minicart_Mly_5g_CBandPro ? planInfo?.[0]?.minicart_Mly_5g_CBandPro : planInfo?.[0]?.minicart_Mly_5g;
    return planInfo?.[0]?.minicart_Tdy_5g_CBandPro ? planInfo?.[0]?.minicart_Tdy_5g_CBandPro : planInfo?.[0]?.minicart_Tdy_5g;
  };

  const renderDueTodayProduct = (item, LoanTermLTE) => {
    const { planInfo, equipmentUpgradeTitle, equipmentUpgradeValue, mtnValue } = filterProducts(item, plansReferenceData); // this.props.EUPDetails;
    let prodName;
    const flowType = getFlowType();
    if (item.description) {
      prodName = item.description;
    } else if (planInfo && planInfo.length > 0) {
      if (flowType === 'LTE') {
        prodName = planInfo[0].minicart_Tdy_lte;
      } else if (isCBandProQualifiedSession()) {
        prodName = getProdNameorCBandProQualifiedSession('daily', planInfo);
      } else {
        prodName = planInfo[0].minicart_Tdy_5g;
      }
    }
    const planID = prodName?.replace(/\s/g, '');
    const isTgwFlow = getSession('isTGW');
    return (
      <>
        {item.description && (
          <CommonSection
            leftValueText={prodName}
            rightValueText={
              <>
                {(flowType === 'LTE' &&
                  item.cartItemType === 'DEVICE' &&
                  // !item.isHomePhone &&
                  item.itemPrice &&
                  item.itemPrice === '0.0' &&
                  item.discountedPrice &&
                  item.discountedPrice !== '0.0') ||
                (item.itemType === 'ACCESSORY' && item.bundleProductId && isTgwFlow) ? (
                  'Included'
                ) : item.totalPriceWithDiscount && item.totalPriceWithDiscount !== parseFloat(item.itemPrice * (item?.qty || 1)).toFixed(2) ? (
                  <>
                    <div>{`$${parseFloat(item?.totalPriceWithDiscount ).toFixed(2)}`}</div>
                    {parseFloat(item?.totalPriceWithDiscount ).toFixed(2) !== parseFloat(item?.itemPrice * (item?.qty || 1)).toFixed(2) && <div className="textDecoration">{`$${parseFloat(item?.itemPrice * (item?.qty || 1)).toFixed(2)}`}</div> }
                  </>
                ) : item.discountedPrice && item.discountedPrice !== '0.0' && item.totalPriceWithDiscount && item.itemPrice ? (
                  item.itemNrpPrice && item.totalPriceWithDiscount ? (
                    `${item.totalPriceWithDiscount !== '0.0' ? `$${parseFloat(item.totalPriceWithDiscount).toFixed(2)}` : 'Included'}`
                  ) : (
                    <>
                      <div>{`$${parseFloat(item.totalPriceWithDiscount).toFixed(2)}`}</div>
                      <div className="textDecoration">{`$${parseFloat(item.itemPrice * (item?.qty || 1)).toFixed(2)}`}</div>
                    </>
                  )
                ) : (
                  // item.discountedPrice &&
                  // item.discountedPrice === '0.0' &&
                  item.itemPrice && `${item.itemPrice !== '0.0' ? `$${parseFloat(item.itemPrice).toFixed(2)}` : 'Included'}`
                )}
              </>
            }
            id={planID}
            className="normalStyle"
            subTitle={
              <>
                {getLTEUpgrade() && equipmentUpgradeTitle !== '' ? (
                  <div>
                    <div>{equipmentUpgradeTitle}</div>
                    <div>
                      {equipmentUpgradeValue}
                      <span className="MTNValue">{mtnValue}</span>
                    </div>
                  </div>
                ) : (
                  ''
                )}

                {item &&
                  LoanTermLTE !== '0' &&
                  item.cartItemType === 'ACCESSORY' &&
                  !item.bundleProductId &&
                  !item.giftCard &&
                  `Quantity: ${item.qty}`}
              </>
            }
          />
        )}
      </>
    );
  };

  const renderDueMonthlyProd = (item) => {
    let { planInfo } = filterProducts(item, plansReferenceData, '');
    let prodName;
    const flowType = getFlowType();
    if (item.pricePlanDisplayName) {
      prodName = item.pricePlanDisplayName;
    } else if (planInfo && planInfo.length > 0) {
      if (flowType === 'LTE') {
        prodName = planInfo[0].minicart_Mly_lte;
      } else if (isCBandProQualifiedSession()) {
        prodName = getProdNameorCBandProQualifiedSession('monthly');
      } else {
        prodName = planInfo[0].minicart_Mly_5g;
      }
    }
    let npaNXXValue;
    let npaNXXValueFromAPI;
    if (npaNXXVal) {
      const phoneNumber = getItemFromStore('home_line');
      const value = phoneNumber && phoneNumber !== '' && `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}`;
      npaNXXValue = value && value !== '' && value.concat('-XXXX');
      if (npaNXXVal) {
        const phoneNumberFromAPI = npaNXXVal;
        const spilittedValue = phoneNumberFromAPI && `${phoneNumberFromAPI.slice(0, 3)}-${phoneNumberFromAPI.slice(3, 6)}`;
        npaNXXValueFromAPI = spilittedValue && spilittedValue.concat('-XXXX');
      } else {
        npaNXXValueFromAPI = '';
      }
    }
    let discountApplicable = false;
    let discountAmountFlag = false;
    if (item?.type?.includes('DISCOUNT')) {
      prodName = item?.description;
      discountApplicable = true;
      if (item?.description?.startsWith('Auto') && item?.type?.includes('DISCOUNT') && flowType === 'LTE') {
        planInfo = getProductRefData('LTEAUTOPAY', '', plansReferenceData);
      } else if (item?.description?.includes('Loyalty') && item?.type?.includes('DISCOUNT') && flowType === 'LTE') {
        planInfo = getProductRefData('LTELOYALTY', '', plansReferenceData);
      }
      if (item?.accountDiscount) {
        discountAmountFlag = true;
      }
    }

    return (
      <>
        {getAPPID() === 'AAL' ? (
          item &&
          prodName && (
            <CommonSection
              leftValueText={prodName}
              rightValueText={
                discountApplicable ? (
                  discountAmountFlag ? (
                    `-$${parseFloat(Math.abs(item.amountOff)).toFixed(2)}`
                  ) : (
                    'Included'
                  )
                ) : item.totalAmountWithDiscount && item.actualAmount && item.totalAmountWithDiscount !== item.actualAmount ? (
                  <>
                    <div>{`$${parseFloat(item.totalAmountWithDiscount).toFixed(2)}`}</div>
                    <div className="textDecoration">{`$${parseFloat(item.actualAmount).toFixed(2)}`}</div>
                  </>
                ) : (
                  item.planPriceWithDiscount !== null &&
                  item.planPriceWithDiscount !== undefined &&
                  item.planPriceWithDiscount !== '' &&
                  `$${parseFloat(item.planPriceWithDiscount).toFixed(2)}`
                )
              }
              id="Product Info"
              className="normalStyle"
              subTitle={
                item.cartItemType &&
                item.cartItemType === 'DEVICE' &&
                flowType === 'LTE' &&
                !item.isHomePhone && (
                  <>
                    {planInfo && planInfo.length > 0 && planInfo[0].dueMonthlyText ? planInfo[0].dueMonthlyText : '24 Monthly Payments'}
                    {dueMonthlyAmount && dueMonthlyAmount.downPaymentAmount > 0 && <p>{`with $${item.sbdOfferAmount}/mo credit applied`}</p>}
                  </>
                )
              }
            />
          )
        ) : (
          <CommonSection
            leftValueText={prodName}
            rightValueText={
              <>
                {item.cartItemType === 'DISCOUNT' &&
                prodName &&
                (prodName?.startsWith('Auto') ||
                  item?.isCouponDiscount ||
                  prodName?.includes('Loyalty') ||
                  prodName?.includes('Employee') ||
                  prodName?.includes('Unlimited')) &&
                item.totalAmountWithDiscount
                  ? 'Included'
                  : item.cartItemType === 'DEVICE' && Math.sign(item.totalAmountWithDiscount) === -1 && dueMonthlyAmount.downPaymentAmount > 0
                    ? `${item.totalAmountWithDiscount === '0.0' ? 'Included' : `$${Math.abs(parseFloat(item.totalAmountWithDiscount).toFixed(2))}`}
                          Credit`
                    : flowType !== 'LTE' && item.planPrice === '0.0'
                      ? 'Included'
                      : item.planPriceWithDiscount
                        ? `$${parseFloat(item.planPriceWithDiscount).toFixed(2)}`
                        : `$${parseFloat(item.thisMonthCharge).toFixed(2)}`}
              </>
            }
            id="Product Info"
            className="normalStyle"
            subTitle={
              <>
                {npaNXXVal && (npaNXXVal ? npaNXXValueFromAPI : npaNXXValue && npaNXXValue)}
                {item.cartItemType && item.cartItemType === 'DEVICE' && flowType === 'LTE' && !item.isHomePhone && (
                  <div>
                    {planInfo && planInfo[0].dueMonthlyText ? planInfo[0].dueMonthlyText : '24 Monthly Payments'}
                    {dueMonthlyAmount && dueMonthlyAmount.downPaymentAmount > 0 && <p>{`with $${item.sbdOfferAmount}/mo credit applied`}</p>}
                  </div>
                )}
                {/* since  the ui doesnt have after setup for homephone , commented this condition
                  //   {item.itemType && item.itemType === 'PLAN' && item.isHomePhone && (
                  //     this.planInfo && this.planInfo.length > 0 && this.planInfo[0].activateText ? this.planInfo[0].activateText : 'After setup*'
                  //   )} */}

                {item.itemType &&
                  item.itemType.map(
                    (val) =>
                      (val.isAdd118On || val.isOCC) &&
                      (val.isSPO
                        ? planInfo && planInfo.length > 0 && planInfo[0].activateText
                          ? `${planInfo[0].activateText} ${taxFeeText || ''}`
                          : `After Activation ${taxFeeText || ''}`
                        : planInfo && planInfo.length > 0 && planInfo[0].activateText
                          ? `${planInfo[0].activateText}`
                          : 'After Activation'),
                  )}
              </>
            }
          />
        )}
      </>
    );
  };

  return (
    <>
      {dueTodayList && dueTodayList?.deviceItem && renderDueTodayProduct(dueTodayList.deviceItem)}
      {dueTodayHomePhoneList && dueTodayHomePhoneList?.deviceItem && renderDueTodayProduct(dueTodayHomePhoneList.deviceItem, plansReferenceData)}
      {dueTodayList && dueTodayList?.accessories && dueTodayList?.accessories?.map((item) => renderDueTodayProduct(item, plansReferenceData))}
      {dueMonthlyProd && dueMonthlyProd && renderDueMonthlyProd(dueMonthlyProd)}
      {dueMonthlyProd &&
        dueMonthlyProd?.planDiscountList?.map((item) =>
          isVFEligibile() ? item?.name?.indexOf('Verizon Forward') === -1 && renderDueMonthlyProd(item) : renderDueMonthlyProd(item),
        )}

      {dueMonthlyList && dueMonthlyList?.accountLevelCharges?.map((item) => renderDueMonthlyProd(item))}
    </>
  );
};

Product.propTypes = {
  dueTodayList: PropTypes.object,
  plansReferenceData: PropTypes.object,
  dueMonthlyList: PropTypes.string,
  dueMonthlyAmount: PropTypes.number,
  dueMonthlyProd: PropTypes.object,
  dueTodayHomePhoneList: PropTypes.object,
  taxFeeText: PropTypes.string,
  npaNXXVal: PropTypes.string,
};
export default Product;
